/****************************************************
 * Module Name:  notificationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class NotificationProxy {
  static GetAllNotification = (callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleNotification = (notificationId, callback) => {
    let params = {
      id: notificationId,
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUnreadNotificationForUserCount = (
    user,
    includeDeleted,
    callback
  ) => {
    let params = {
      user: user,
      includedeleted: includeDeleted,
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification/unread/count",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetNotificationsForUsers = (user, includeDeleted, callback) => {
    let params = {
      user: user,
      includedeleted: includeDeleted,
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetNotificationsForUsersByLimit = (user, includeDeleted, limit, callback) => {
    let params = {
      user: user,
      includedeleted: includeDeleted,
      limit: limit
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetNotificationsBetweenUsers = (
    user1,
    user2,
    includeDeleted,
    callback
  ) => {
    let params = {
      user1: user1,
      user2: user2,
      includedeleted: includeDeleted,
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLatestNotificationsBetweenUsers = (
    id,
    user1,
    user2,
    includeDeleted,
    callback
  ) => {
    let params = {
      user1: user1,
      user2: user2,
      includedeleted: includeDeleted,
    };

    restAPICall(
      Constants.NOTIFICATION_URL + `/notification/latest/${id}`,
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetNotificationsBetweenUsersByLimitOffset = (
    user1,
    user2,
    includeDeleted,
    offset,
    limit,
    callback
  ) => {
    let params = {
      user1: user1,
      user2: user2,
      includedeleted: includeDeleted,
      offset: offset,
      limit: limit
    };

    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "get",
      undefined,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddNotification = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "post",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddMultipleNotification = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification/multiple",
      "post",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateNotification = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "put",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateMultipleNotificationStatus = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification/status",
      "put",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteNotification = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification",
      "delete",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteMultipleNotification = (notification, callback) => {
    restAPICall(
      Constants.NOTIFICATION_URL + "/notification/multiple",
      "delete",
      undefined,
      undefined,
      JSON.stringify(notification),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
